// Mock data for NRFSTR website

export const companyInfo = {
  name: "NRFSTR",
  fullName: "Norf Star",
  tagline: "Building the future, one innovation at a time",
  description: "A tech company that builds digital products and software under its own umbrella",
  email: "Tyseandavis42@gmail.com"
};

export const products = [
  {
    id: "aim-lc",
    name: "AiM LC",
    tagline: "AI-Managed Lifecycle Control",
    description: "AiM LC (AI-Managed Lifecycle Control) is a local-first enterprise software platform developed by NRFSTR to help organizations manage the growing complexity of AI and machine learning infrastructure.",
    fullDescription: "As AI environments expand, organizations accumulate thousands of models, datasets, checkpoints, experiment artifacts, logs, and other machine learning assets. Without effective lifecycle management, these assets can increase storage costs, waste computing resources, create compliance challenges, and make infrastructure more difficult to manage. AiM LC continuously monitors approved AI/ML environments, intelligently analyzes artifact usage, and recommends safe optimization actions to reduce unnecessary infrastructure costs while preserving reliability and maintaining human oversight.",
    features: [
      "Intelligent AI/ML artifact discovery and organization",
      "Lifecycle tracking and optimization recommendations",
      "Cost and ROI analysis",
      "Safe archival, compression, and recovery workflows",
      "Configurable automation policies",
      "Audit logging and compliance reporting",
      "Local encrypted backup and recovery",
      "Enterprise-grade security and access controls",
      "Offline-first operation with minimal internet requirements"
    ],
    benefits: "Make AI infrastructure easier to manage, more cost-efficient, more transparent, and more secure—while keeping your data where it belongs: under your control.",
    audience: "Research teams, AI startups, enterprise organizations, and data centers",
    logo: "/images/aim-logo.png",
    availability: "Available for download on this site when ready",
    comingSoon: true
  },
  {
    id: "scriptotter",
    name: "ScriptOtter",
    tagline: "Professional screenwriting, simplified",
    description: "ScriptOtter is a professional screenwriting application designed to help writers plan, draft, edit, and manage scripts with speed and clarity. It provides a focused, distraction-free writing environment combined with essential production-ready tools.",
    features: [
      "Industry-standard format support (Fountain, FDX)",
      "Distraction-free writing environment",
      "Local storage for privacy and instant access",
      "Project management and structured editing",
      "Cross-platform support (iPhone, iPad, Mac)",
      "Seamless file sharing via AirDrop and Files app"
    ],
    benefits: "Move from idea to finished script without friction. Fast, intuitive, and dependable.",
    audience: "Screenwriters, filmmakers, and content creators",
    logo: "/images/scriptotter-logo.png",
    availability: "Available on the App Store",
    comingSoon: true
  },
  {
    id: "gigma",
    name: "Gigma",
    tagline: "Build your Google Business Profile the right way",
    description: "Gigma is a step-by-step web app that helps businesses, schools, churches and other local organizations build a Google Business Profile the right way — with a live Google Search preview before publishing and a one-time $9.99 payment.",
    features: [
      "Guided 10-step wizard for complete profile setup",
      "Live Google Search preview as you type",
      "Interactive Publish Assistant with one-tap Copy buttons",
      "Built-in Review Kit with printable QR code",
      "All data lives in your browser - no accounts, no subscriptions",
      "Lifetime access after one-time payment"
    ],
    benefits: "Create a professional Google Business Profile in minutes with instant preview and guided publishing.",
    audience: "Local businesses, schools, churches, and organizations",
    logo: "/images/gigma-logo.png",
    availability: "Available now",
    link: "https://gigma.nrfstr.com",
    comingSoon: false
  }
];

export const aboutContent = {
  story: "NRFSTR (Norf Star) was founded with a singular vision: to build innovative digital products that push the boundaries of what's possible. We believe in creating tools that empower creators, streamline workflows, and unlock new possibilities.",
  mission: "Our mission is to develop cutting-edge software solutions that solve real problems and inspire creativity. We build products that we ourselves want to use—tools that are powerful, intuitive, and beautifully designed.",
  vision: "We envision a future where technology seamlessly integrates with human creativity, enabling anyone to bring their ideas to life. Through continuous innovation and a commitment to excellence, we're building that future, one product at a time.",
  approach: "At NRFSTR, we combine technical excellence with thoughtful design. Every product we build is crafted with attention to detail, user experience, and performance. We believe in simplicity, elegance, and the power of great software."
};

export const contactFormFields = {
  name: "",
  email: "",
  subject: "",
  message: ""
};

export const newsletterEmail = "";
